// src/components/Footer.js
import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 2rem;
  background: #333;
  color: #fff;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <p>&copy; 2024 AdChain. All rights reserved.</p>
    </FooterContainer>
  );
};

export default Footer;
